import Vue from 'vue';
import 'iview/dist/styles/iview.css';
import iView from 'iview';

Vue.use(iView,{
    transfer: true,
});
